import { CashResponse, CashResponseMiddleware } from '@cash-web/shared-util-fetch'

import { FlowResponse, FlowStateDispatch } from '../utils'
export const getPaymentTokens = (response: CashResponse<FlowResponse>) => {
  const responseContext = response?.response_context
  const paymentTokens: string[] | undefined = responseContext?.payments
    ?.map(payment => payment.token)
    .filter((token): token is string => Boolean(token))

  return paymentTokens
}
export const createSetPaymentTokensMiddleware =
  ({ state, dispatch }: FlowStateDispatch): CashResponseMiddleware =>
  (response: CashResponse<FlowResponse>, context) => {
    const paymentTokens = getPaymentTokens(response)

    // guard
    if (
      paymentTokens == null ||
      paymentTokens.length === 0 ||
      paymentTokens.join('-') === state.paymentTokens?.join('-')
    ) {
      return response
    }

    // action
    dispatch({
      type: 'SET_PAYMENT_TOKENS',
      paymentTokens,
    })

    return response
  }
